import { render, staticRenderFns } from "./CockpitMatryoshkaItemOperations.vue?vue&type=template&id=2cf935a4&scoped=true"
import script from "./CockpitMatryoshkaItemOperations.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemOperations.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemOperations.vue?vue&type=style&index=0&id=2cf935a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf935a4",
  null
  
)

export default component.exports